import { render, staticRenderFns } from "./JudgementUpdateConfirmModal.vue?vue&type=template&id=7187c354&lang=pug"
import script from "./JudgementUpdateConfirmModal.vue?vue&type=script&lang=ts"
export * from "./JudgementUpdateConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports